import * as getters from '@/store/modules/exchanges/getters'
import * as mutations from '@/store/modules/exchanges/mutations'
import * as actions from '@/store/modules/exchanges/actions'

const state = {
    exchangeTableWithValue: [],
    exchangeTableList: [],
    lastUpdateDate: null
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
